module.exports = __webpack_public_path__ + "static/chose-108fb7775573ae97d89a4c3d859fd5c6.png";